module.exports = __webpack_public_path__ + "assets/img/xiangyoujiantou.a255c731.svg";